export default __webpack_public_path__ + "locales/fi/Files.json?hash=d3c55313d3fc28b7f7d5b146acf81f81";